import { render, staticRenderFns } from "./kurulumlar.vue?vue&type=template&id=2d2c2e55&scoped=true&"
import script from "./kurulumlar.vue?vue&type=script&lang=js&"
export * from "./kurulumlar.vue?vue&type=script&lang=js&"
import style0 from "./kurulumlar.vue?vue&type=style&index=0&id=2d2c2e55&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2c2e55",
  null
  
)

export default component.exports